/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { getClientHints } from '#utils/PRIVATE_clientHints';

const clientHints = getClientHints();

/**
 * Helper function to determine whether the current device is a mobile device
 * @returns true if runnning on a mobile device, false otherwise
 */
export function isMobile() {
  const deviceType = clientHints.deviceType;
  return deviceType === 'phone' || deviceType === 'tablet';
}
